import {
  FAQS,
  TERMS_AND_CONDITION,
  REGISTER_TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const reservation_sandbox_pass: TTeamConfig = {
  TEAM_SCHEMA: "reservation_sandbox_pass",
  CLIENT_ID: "9905940d1e7e.seasonshare.integ3-sandbox.us",
  TEAM_FULL_NAME: "Clemson Tigers",
  BROWSER_TITLE: "Clemson Paw Pass",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/clemson/",
    COLORS_PRIMARY: "#F56600",
    COLORS_SECONDARY: "#522D80",
    DEFAULT_APP_ROUTE: routes.landing,
    IS_CROWD_HANDLER_ENABLED: true,
    DISABLE_SIT_WITH_FRIENDS: true,
    //ANALYTICS_HEADER: AnalyticsHeader,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    IS_INTERCOM_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_PASSES_UNDER_BANNER: true,
    HIDE_UPCOMING_EVENTS: true,
  },

  HOME_PAGE_SETTINGS: {
    DEFAULT_PAGE_TOP_NOTIFICATION: {
      DESCRIPTION:
        "You can hold and manage up to three (3) different game reservations at a time. Once a reserved game passes, you can come back to reserve another game.",
      BACKGROUND_COLOR: "#522D80",
    },
    ATTEND_EVENT_MODAL: {
      TITLE: "Manage Reservation",
      DESCRIPTION: (
        <>
          By reserving a game you are committing to attend. If you are unable to
          attend, please cancel as early as possible so the seat can be made
          available to other pass holders.
        </>
      ),
      PAID_RESERVATION_DESCRIPTION: (
        <>
          This game requires an additional payment to reserve your seat.
          Clicking <strong>Reserve</strong> will take you to checkout to
          complete your purchase.
        </>
      ),
      CHANGE_SEAT_COUNT_BUTTON_LABEL: "Change Seat Count",
      ATTEND_BUTTON_LABEL: "Reserve",
      NOT_ATTENDING_BUTTON_LABEL: "Cancel Reservation",
      ATTEND_BUTTON_ATTENDING_LABEL: "Reserved",
      ATTEND_BUTTON_NOT_ATTENDING_LABEL: "Not Reserved",

      ATTENDANCE_SUCCESS_TOAST: {
        OPT_IN_SUCCESS_MESSAGE:
          "Your reservation has been updated successfully.",
        OPT_OUT_SUCCESS_MESSAGE:
          "Your reservation has been cancelled successfully.",
      },
    },

    EXCHANGE_RESERVATION_MODAL: {
      DESCRIPTION: (
        <>
          Swap this game in for one of your existing reservations. Your new
          reservation will be confirmed and the selected reservation will be
          cancelled in a single step.
        </>
      ),
      PAID_DESCRIPTION: (
        <>
          This game requires an additional payment to reserve your seat.
          Clicking <strong>Confirm Exchange</strong> will take you to checkout
          to complete your purchase, after which your selected reservation will
          be cancelled.
        </>
      ),
    },

    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_LABEL: "Reserve",

      IS_RESERVATION_ENABLED: true,
      IS_RESERVATION_EXCHANGE_ENABLED: true,

      RESERVATION_LIMIT_REACHED_MESSAGE:
         "You've reached the maximum of three (3) active game reservations. Once one of your reserved games has passed, you'll be able to make a new reservation.",
         
      RESERVATION_ADD_ON_SEATS_CLAIMED_MESSAGE:
        "This reservation cannot be canceled because additional guest tickets have been purchased for the event.",

      SEAT_COUNT_LIMIT_REACHED_MESSAGE:
        "All seats for this event have been reserved. Please check back in case additional seats become available.",
    },

    ADD_ON: {
      OPT_IN_REQUIRED_MESSAGE:
        "Please complete your pass reservation before purchasing additional guest seats.",
    },

    ZERO_STATE: {
      TITLE: " ",
      DESCRIPTION:
        "No events are currently available for purchase. Please check back later.",
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTER_TERMS_AND_CONDITION />,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  PURCHASE_HISTORY_PAGE_SETTINGS: {
    IS_RESEVATION_HISTORY_ENABLED: true,

    PURCHASE_HISTORY_ZERO_STATE: {
      TITLE: "No orders yet",
      DESCRIPTION: "Only purchases made on this platform will appear here.",
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/clemson-logo-transparent.png",

    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Clemson/clemson-order-summary.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
